import { useQuery } from '@tanstack/react-query'
import { IMilkingScheduleResponse } from 'models/MilkingProcess'
import MilkingProcessService from 'services/milkingProcessService'

export const useGetMilkingScheduleSettingsQuery = () => {
	const { data, refetch, isError, isLoading } = useQuery<
		IMilkingScheduleResponse[]
	>({
		queryKey: ['milking-schedule-settings'],
		queryFn: async () => await MilkingProcessService.getMilkingSchedule(),
		staleTime: 50000,
	})

	return {
		data,
		isLoading,
		isError,
		refetch,
	}
}
